<template>
  <div class="text-center">
    <v-dialog
      width="600"
      :value="alertRefCode.isShow"
      persistent
    >
      <v-card>
        <v-card-text class="tw-mt-8">
          <p v-if="alertRefCode.alertStatus === 'success'" class="tw-text-lg tw-font-bold">กรอก Referral Code เพื่อแพ็คเกจพิเศษสำเร็จ</p>
          <p v-else class="tw-text-lg tw-font-bold">ตรวจพบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onCloseAlert(false)">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'AlertPackage',
  computed: mapState({
    alertRefCode: state => state.companies.alertRefCode,
  }),
  methods: {
    onCloseAlert: function () {
      this.$store.dispatch('companies/setAlertRefCode',{alertRefCode :{isShow: false, alertStatus: ""}})
    },
  }
}
</script>
